<script setup lang="ts">
let props = defineProps({
  enabled: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
  <svg id="fi_14896317" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" width="24" height="24"
       class="tw-fill-[#606060] dark:tw-fill-white">
    <path
      d="m500.39 866h-100.78a16 16 0 0 1 -16-16v-102.84a253.41 253.41 0 0 1 -61.42-25.46l-72.74 72.72a16 16 0 0 1 -22.63 0l-71.24-71.24a16 16 0 0 1 0-22.63l72.72-72.74a253.41 253.41 0 0 1 -25.46-61.42h-102.84a16 16 0 0 1 -16-16v-100.78a16 16 0 0 1 16-16h102.84a253.41 253.41 0 0 1 25.46-61.42l-72.72-72.74a16 16 0 0 1 0-22.63l71.24-71.24a16 16 0 0 1 22.63 0l72.74 72.72a253.41 253.41 0 0 1 61.42-25.46v-102.84a16 16 0 0 1 16-16h100.78a16 16 0 0 1 16 16v700a16 16 0 0 1 -16 16zm-84.78-32h68.78v-668h-68.78v99.44a16 16 0 0 1 -12.61 15.65 221.8 221.8 0 0 0 -74.52 30.91 16 16 0 0 1 -20-2.12l-70.33-70.32-48.62 48.62 70.32 70.33a16 16 0 0 1 2.12 20 221.8 221.8 0 0 0 -30.88 74.49 16 16 0 0 1 -15.65 12.65h-99.44v68.78h99.44a16 16 0 0 1 15.65 12.57 221.8 221.8 0 0 0 30.91 74.52 16 16 0 0 1 -2.12 20l-70.32 70.33 48.62 48.62 70.33-70.32a16 16 0 0 1 20-2.12 221.8 221.8 0 0 0 74.49 30.88 16 16 0 0 1 12.65 15.65z"></path>
    <path
      d="m451.75 673.5c-95.67 0-173.5-77.83-173.5-173.5s77.83-173.5 173.5-173.5a173 173 0 0 1 53.59 8.5 16 16 0 0 1 11.05 15.21v299.62a16 16 0 0 1 -11.05 15.17 173 173 0 0 1 -53.59 8.5zm0-315c-78 0-141.5 63.48-141.5 141.5s63.48 141.5 141.5 141.5a141.47 141.47 0 0 0 32.64-3.79v-275.42a141.47 141.47 0 0 0 -32.64-3.79z"></path>
    <path d="m835 516.12h-334.61a16 16 0 0 1 0-32h334.61a16 16 0 0 1 0 32z"></path>
    <path d="m650.15 306.12h-149.76a16 16 0 0 1 0-32h133.76v-109.12a16 16 0 0 1 32 0v125.12a16 16 0 0 1 -16 16z"></path>
    <path d="m650.15 851a16 16 0 0 1 -16-16v-108.88h-133.76a16 16 0 0 1 0-32h149.76a16 16 0 0 1 16 16v124.88a16 16 0 0 1 -16 16z"></path>
    <path d="m650.15 181a48.5 48.5 0 1 1 48.5-48.5 48.56 48.56 0 0 1 -48.5 48.5zm0-65a16.5 16.5 0 1 0 16.5 16.5 16.52 16.52 0 0 0 -16.5-16.5z"></path>
    <path d="m500.39 411.12a16 16 0 0 1 0-32h238.78l95-95a16 16 0 1 1 22.62 22.63l-99.7 99.7a16 16 0 0 1 -11.31 4.69z"></path>
    <path
      d="m867.5 321.89a48.48 48.48 0 1 1 34.29-14.18 48.31 48.31 0 0 1 -34.29 14.18zm0-65a16.5 16.5 0 1 0 11.67 4.83 16.44 16.44 0 0 0 -11.67-4.8z"></path>
    <path d="m650.19 916a48.5 48.5 0 1 1 48.5-48.5 48.56 48.56 0 0 1 -48.5 48.5zm0-65a16.5 16.5 0 1 0 16.5 16.5 16.52 16.52 0 0 0 -16.5-16.5z"></path>
    <path
      d="m844.52 720.82a15.91 15.91 0 0 1 -11.31-4.69l-95-95h-237.82a16 16 0 0 1 0-32h244.43a16 16 0 0 1 11.31 4.68l99.7 99.71a16 16 0 0 1 -11.31 27.31z"></path>
    <path
      d="m867.5 776.28a48.49 48.49 0 1 1 34.29-82.77 48.48 48.48 0 0 1 -34.3 82.77zm0-65a16.49 16.49 0 1 0 11.67 4.82 16.48 16.48 0 0 0 -11.67-4.79z"></path>
    <path
      d="m867.5 548.62a48.5 48.5 0 1 1 48.5-48.5 48.56 48.56 0 0 1 -48.5 48.5zm0-65a16.5 16.5 0 1 0 16.5 16.5 16.52 16.52 0 0 0 -16.5-16.5z"></path>
    <g transform="translate(60, 90) scale(21)" v-if="enabled">
      <path d="M0.322,1.905c-0.429-0.429-0.429-1.143,0-1.571c0.444-0.444,1.143-0.444,1.587,0l39.252,39.253
	      c0.444,0.444,0.444,1.143,0,1.587c-0.429,0.429-1.143,0.429-1.571,0L0.322,1.905z"></path>
    </g>
  </svg>
</template>

<style scoped>

</style>
